"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_collapsible_1 = __importDefault(require("react-collapsible"));
const react_i18next_1 = require("react-i18next");
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true, error: error, info: info });
        console.log('An exception occurred in a react component', error, info);
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (react_1.default.createElement("div", { className: "tr__panel" },
                react_1.default.createElement("h1", null, this.props.t('main:errors:ExceptionOnPage')),
                react_1.default.createElement("h3", null, this.props.t('main:errors:ShowExceptionForCopy')),
                react_1.default.createElement(react_collapsible_1.default, { trigger: this.props.t('main:errors:Exception'), open: false, transitionTime: 100 },
                    react_1.default.createElement("div", { className: "tr__exception" },
                        react_1.default.createElement("span", null, this.state.error && this.state.error.message),
                        react_1.default.createElement("span", null, this.state.info && this.state.info.componentStack)))));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
exports.default = (0, react_i18next_1.withTranslation)('main')(ErrorBoundary);
//# sourceMappingURL=ErrorBoundary.js.map